import {
  MEMBERS_ONLY_SALE,
  MEMBERS_SALE_LIVE,
  MEMBERS_PRE_SALE
} from "../../../modules/config/constants";
import { isLiveDate } from "./isLiveDate";

const getMembersOnlySaleType = benefits =>
  benefits.find(benefit => benefit.type === MEMBERS_ONLY_SALE);

const isMembersDayEvent = membersOnlySaleEvents =>
  membersOnlySaleEvents?.eventSchedule?.events?.find(
    item => item.subType === MEMBERS_SALE_LIVE
  );

const isPreSaleEvent = membersOnlySaleEvents =>
  membersOnlySaleEvents?.eventSchedule?.events?.find(
    item => item.subType === MEMBERS_PRE_SALE
  );

const getActiveMembersDaySaleEvent = config => {
  const benefits = config?.benefits;
  if (!benefits) {
    return null;
  }

  let activeEvent = null;
  const membersOnlySaleEvents = getMembersOnlySaleType(benefits);

  const membersDayEvent = isMembersDayEvent(membersOnlySaleEvents);

  const checkForPresale = () => {
    const preSaleEvent = isPreSaleEvent(membersOnlySaleEvents);
    if (preSaleEvent) {
      const preSaleLive = isLiveDate(preSaleEvent);
      if (preSaleLive) {
        activeEvent = preSaleEvent.subType;
      }
    }
  };

  if (membersDayEvent && isLiveDate(membersDayEvent)) {
    activeEvent = membersDayEvent.subType;
  } else {
    checkForPresale();
  }

  return activeEvent;
};

export default getActiveMembersDaySaleEvent;
